import React from "react";
import { Button, Column, Conditional, Else, Heading, If, makeClassName, Modal, ModalProps } from "@hex-insights/core";
import { EmptyView } from "../../../../Components/Empty";
import { Icon } from "../../../../Components/Icon";
import { Student, StudentDataConsentDetailFragment, StudentNameAndImageFragment } from "../../../../Utilities";
import { StudentDataConsentCreateModal } from "../CreateModal";
import { StudentDataConsentDetailDisplay } from "../DetailDisplay";
import { StudentDataConsentCreatePermissionRequired } from "../PermissionRequired";
import styles from "./styles.module.css";

export type StudentDataConsentModalProps = {
	student: Pick<Student, "id"> & StudentNameAndImageFragment;
	isLoading?: boolean;
	studentDataConsent: StudentDataConsentDetailFragment | null | undefined;
} & Pick<ModalProps, "ifRef" | "onClose" | "className" | "style">;

export function StudentDataConsentModal({
	student,
	isLoading = false,
	studentDataConsent,
	ifRef,
	onClose,
	className,
	style,
}: StudentDataConsentModalProps) {
	return (
		<Modal ifRef={ifRef} onClose={onClose} className={makeClassName(styles["modal"], className)} style={style}>
			<Modal.Header>
				<Heading.H2 noMargin>Data Consent</Heading.H2>
			</Modal.Header>
			<Modal.Body style={{ display: "flex", flexDirection: "column" }}>
				<Conditional>
					<If condition={!!studentDataConsent}>
						{studentDataConsent && (
							<StudentDataConsentDetailDisplay student={student} studentDataConsent={studentDataConsent} />
						)}
					</If>
					<If condition={isLoading}>
						<Column justify="center" align="center" style={{ flexGrow: 1 }}>
							Loading...
						</Column>
					</If>
					<Else>
						<EmptyBodyContent student={student} />
					</Else>
				</Conditional>
			</Modal.Body>
		</Modal>
	);
}

type EmptyBodyContentProps = {
	student: Pick<Student, "id">;
};

function EmptyBodyContent({ student }: EmptyBodyContentProps) {
	const { isModalOpen, openModal, closeModal } = Modal.useToggle();

	return (
		<React.Fragment>
			<EmptyView
				IconComponent={Icon.UserList}
				primaryText="Data Consent"
				secondaryText="No data consent submission found for this student"
			>
				<StudentDataConsentCreatePermissionRequired>
					<Button variant="link" size="small" onClick={openModal}>
						Add Data Consent
					</Button>
				</StudentDataConsentCreatePermissionRequired>
			</EmptyView>

			<Modal.If condition={isModalOpen}>
				<StudentDataConsentCreateModal studentID={student.id} onClose={closeModal} />
			</Modal.If>
		</React.Fragment>
	);
}
